import { InstagramOutlined } from '@ant-design/icons';
import { Button, Skeleton } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { URLPreviewData, isInstagramPostPreviewData } from '../../../utils/urlPreview';

interface ChatInstagramCaptionProps {
    url: string;
    urlPreviewPromise: Promise<URLPreviewData[]>;
}

export default function ChatInstagramCaption({ url, urlPreviewPromise }: ChatInstagramCaptionProps) {
    const { t } = useTranslation('tickets');
    const [loading, setLoading] = useState<boolean>(true);
    const [preview, setPreview] = useState<URLPreviewData | undefined>();

    // TODO: seek for the validity of below implementation for promise
    try {
        urlPreviewPromise.then((previews) => {
            setPreview(previews?.[url]);
            setLoading(false);
        });
    } catch (e) {
        setLoading(false);
    }

    if (loading) {
        return (
            <div className="gsocial-chat-list__caption">
                <Skeleton.Input size="small" active={true} />
            </div>
        );
    }

    if (!preview?.data) {
        return null;
    }

    if (!isInstagramPostPreviewData(preview)) {
        return null;
    }

    return (
        <div className="gsocial-chat-list__caption">
            <div>{preview?.data?.caption}</div>
            <Button href={url} size="small" icon={<InstagramOutlined />} style={{ marginTop: '0.5rem' }}>
                {t('viewOnInstagram')}
            </Button>
        </div>
    );
}
